<template>
  <div class="set-font pt-6">
    <div class="d-flex justify-space-between text-color font-weight-bold">
      <div>Supplied:</div>
      <div>{{ amountHint }}</div>
    </div>

    <div v-if="infraredRewards">
      <div v-for="item in infraredRewards" :key="item.address" class="d-flex justify-space-between text-color font-weight-bold">
        <div>{{ item.name }} Reward:</div>
        <div>{{ item.earned }}</div>
      </div>
    </div>

    <!-- Amount Section -->
    <amount-input
      label="Withdraw Amount"
      v-model="amount"
      :focus="focus"
      :hint="amountHint"
      hideDetails
      :maxVal="maxVal"
      @maxClicked="maxClicked"
    />

    <!-- Rates Section -->
    <!-- <deposit-rate-section :depositAPY="depositAPY" :rewardAPY="rewardAPY" /> -->

    <borrow-limit-section :market="value" />

    <connect-wallet></connect-wallet>

    <div class="mt-4">
      <v-alert v-if="actionBtnDisabled && actionBtnDisabled !== 'empty'" type="warning" dense>{{ actionBtnDisabled }}</v-alert>
    </div>

    <v-btn color="accent" :class="[actionBtnDisabled ? 'mt-4' : 'mt-8']" :disabled="!!actionBtnDisabled" large block @click="withdraw(amount)">
      {{ computedWithdrawText }}
    </v-btn>

    <v-btn v-if="totalEarned" class="mt-4" color="accent" :disabled="!!claimBtnDisabled" large block @click="claim()">
      Claim Reward
    </v-btn>
    <!-- <div>exchangeRateCurrent: {{ value.exchangeRateCurrent }}</div>
    <div>underlyBalance: {{ value.supplied }}</div>
    <div>cBalance: {{ value.cTokenBalance }}</div> -->
  </div>
</template>
<script>
import { BigNumber } from 'bignumber.js'
import { mapState, mapActions } from 'vuex'
import DepositRateSection from './depositRateSection.vue'
import BorrowLimitSection from './borrowLimitSection.vue'

export default {
  name: 'WithdrawTab',
  components: { DepositRateSection, BorrowLimitSection },
  props: {
    value: {
      type: Object,
      require: true,
    },
    focus: {
      type: Boolean,
      require: true,
      default: false,
    },
  },
  data() {
    return {
      amount: '',
      clickedMax: false,
    }
  },
  created() {
    this.clickedMax = false
  },
  watch: {
    amount(newVal) {
      if (Number(newVal) < Number(this.maxVal)) {
        this.clickedMax = false
      } 
    },
  },
  computed: {
    ...mapState('market', ['infraredInfo']),
    infraredRewards() {
      const ctokenAddr = this.value.ctokenAddr
      if (this.infraredInfo) {
        if (ctokenAddr in this.infraredInfo) {
          return this.infraredInfo[ctokenAddr].rewardTokens
        }

      }

      return null
    },
    totalEarned() {
      let totalEarned = 0
      if (this.infraredRewards) {
        totalEarned = this.infraredRewards.reduce((acc, cur) => acc + cur.earned, 0)
      }
      return totalEarned
    },
    computedWithdrawText() {
      if (this.totalEarned > 0) {
        return `Withdraw and Claim All`
      } else {
        return `Withdraw ${this.value.underlySymbol}`
      }
    },
    claimBtnDisabled() {
      if (this.totalEarned > 0) return false
      return true
    },
    actionBtnDisabled() {
      if (this.amount.trim() === '') {
        return 'empty'
      } else if (Number.isNaN(Number(this.amount))) {
        return 'Invalid balance'
      } else if (Number(this.amount) > Number(this.value.supplied)) {
        return 'Insuffient supplied balance'
      } else if (this.value.isCToken && Number(this.amount) > Number(this.value.totalCash.toFixed())) {
        return 'Insufficient available liquidity for withdraw'
      } else {
        // calc left ctoken balance
        if (!this.clickedMax) {
          const leftCTokenBalanceInWei = new BigNumber(this.value.cTokenBalance).minus(new BigNumber(this.amount).div(this.value.exchangeRateCurrent)).times(`1e${this.value.sdrTokenDecimals}`)
          // console.log('leftCTokenBalanceInWei', leftCTokenBalanceInWei.toFixed())
          if (leftCTokenBalanceInWei.lt(1000)) {
            return 'Must left at least 1000 wei, or you can withdraw all'
          }
        }
      }
      return false
    },
    maxVal() {
      return new BigNumber(String(this.value.supplied)).toFixed()
    },
    amountHint() {
      return `${this.value.supplied}`
    },
  },
  methods: {
    ...mapActions({
      redeem: 'tx/redeem',
      infraredClaim: 'tx/infraredClaim'
    }),
    maxClicked() {
      this.clickedMax = true
    },
    async withdraw(amount) {
      const params = {
        underlySymbol: this.value.underlySymbol,
        underlyOrCTokenSymbol: this.value.underlySymbol,
        amount: new BigNumber(String(amount)).times(`1e${this.value.underlyDecimals}`),
        noDecimalsAmount: new BigNumber(String(amount)).toFixed(),
      }
      if (this.clickedMax) {
        params.underlyOrCTokenSymbol = this.value.sdrSymbol
        params.amount = new BigNumber(String(this.value.cTokenBalance)).times(`1e${this.value.sdrTokenDecimals}`)
      }
      this.redeem(params)
    },
    claim() {
      let symbol = ''
      for (const item of this.infraredRewards) {
        if (symbol) {
          symbol += `/${item.symbol}`
        } else {
          symbol = item.symbol
        }
      }
      // const totalEarned = this.infraredRewards.reduce((acc, cur) => acc + cur.earned, 0)
      this.infraredClaim({ amount: this.totalEarned, symbol, sdrTokenAddress: this.value.ctokenAddr })
    }
  },
}
</script>
